import React from 'react';

import { ThemeContext } from '@neptune/shared/venus-domain';

export function useTheme() {
  const themeContext = React.useContext(ThemeContext);

  if (!themeContext) {
    throw new Error('useTheme must be used within a ThemeProvider or RootThemeProvider');
  }

  return themeContext;
}
